import { gql } from '@apollo/client';

// ************************************************
//                    FRAGMENTS
// ************************************************
export const BASE_ORGANIZATION_FRAGMENT = gql`
  fragment BaseOrganization on BaseOrganization {
    id
    name
    slug
  }
`;

// ************************************************
//                    QUERIES
// ************************************************
export const GET_ORGANIZATION = gql`
  query getOrganization($organizationId: UUID!) {
    organization(organizationId: $organizationId) {
      id
      slug
      name
      type
      users {
        id
        firstName
        lastName
        email
        roleType
      }
    }
  }
`;

export const GET_ORGANIZATION_ACTIVE_CREDIT_FACILITIES = gql`
  query getOrganizationActiveCreditFacilities($organizationId: UUID!) {
    organization(organizationId: $organizationId) {
      id
      slug
      name
      type
      creditFacilities {
        id
        slug
        name
      }
    }
  }
`;

export const GET_ORGANIZATIONS_BY_IDS = gql`
  query getOrganizationsByIds($organizationIds: [UUID!]!) {
    organizationsByIds(organizationIds: $organizationIds) {
      id
      slug
      name
      type
    }
  }
`;

// note: this query has a N+1 pattern, please use with only limited set of organizations
export const GET_ORGANIZATIONS_BY_IDS_WITH_USERS = gql`
  query getOrganizationsByIdsWithUsers($organizationIds: [UUID!]!) {
    organizationsByIds(organizationIds: $organizationIds) {
      id
      slug
      name
      type
      users {
        id
        firstName
        lastName
        email
        roleType
      }
    }
  }
`;

export const GET_CAPITAL_PROVIDERS_FOR_CREDIT_FACILITY = gql`
  query GetCapitalProviders($creditFacilityId: UUID!) {
    capitalProviders(creditFacilityId: $creditFacilityId) {
      id
      name
      type
      slug
    }
  }
`;

export const GET_PARTIES_BY_TYPE_AND_CREDIT_FACILITIES = gql`
  query GetPartiesByTypeAndCreditFacilityIds(
    $creditFacilityIds: [UUID!]!
    $partyType: PartyType!
  ) {
    partiesByTypeAndCreditFacilityIds(
      creditFacilityIds: $creditFacilityIds
      partyType: $partyType
    ) {
      id
      name
      type
      slug
    }
  }
`;

export const GET_ORGANIZATION_LOAN_PRODUCTS = gql`
  query GetOrganizationLoanProducts($organizationId: UUID!) {
    organization(organizationId: $organizationId) {
      id
      slug
      loanProducts {
        id
        name
        slug
        implementationId
        currentMasterLoanTape {
          id
          fileVersion
          reportingDate
        }
      }
    }
  }
`;

export const GET_ORGANIZATION_LOAN_PRODUCTS_BY_CREDIT_FACILITY = gql`
  query GetOrganizationLoanProductsByCreditFacility($organizationId: UUID!) {
    result: organization(organizationId: $organizationId) {
      creditFacilities {
        id
        slug
        name
        loanProducts {
          id
          slug
          name
        }
      }
    }
  }
`;

export const GET_ATHENA_SCHEMA_FOR_ORGANIZATION = gql`
  query GetAthenaSchemaForOrganization(
    # @jendevelops [GLOBAL-FILTERS TODO]: update query to take in UUID instead
    $organizationId: String!
  ) {
    athenaTables: getAthenaTablesForOrganization(
      organizationId: $organizationId
      tablePrefixes: ["receivable_response_tapes"]
    ) {
      tableName
      properties {
        name
        type
      }
    }
  }
`;

// ==== MUTATIONS ====

export const CREATE_USER = gql`
  mutation createUser($userData: CreateUser!) {
    createUser(userData: $userData) {
      id
      firstName
      lastName
      email
      roleType
    }
  }
`;

export const REMOVE_USER = gql`
  mutation removeUser($userId: UUID!, $organizationId: UUID!) {
    removeUser(userId: $userId, organizationId: $organizationId)
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser($settings: UpdateUserSettings!) {
    updateUserSettingsWithRole(settings: $settings) {
      id
      email
      firstName
      lastName
      roleType
    }
  }
`;

export const UPDATE_LOAN_PRODUCT_NAME = gql`
  mutation UpdateLoanProductName($id: UUID!, $newName: String!) {
    updateLoanProductName(id: $id, newName: $newName) {
      name
    }
  }
`;
